import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Mô tả ", -1)
const _hoisted_3 = { style: {"word-break":"break-word !important"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Bạn có chắc chắn muốn xóa dữ liệu này?",
      width: "20%",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingDanhMucToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.deletingDanhMucToaXe.ten_danh_muc), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "cell-class-name": _ctx.isTextDangerColumn,
      "empty-text": "Chưa có danh mục toa xe nào được tạo",
      "max-height": "600",
      style: {"width":"100%"},
      size: "small",
      "cell-style": {padding: '0', height: '10px'},
      border: true,
      data: _ctx.items
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Tên" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_danh_muc), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Mã" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_danh_muc), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Danh mục cha" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.parent?.ten_danh_muc ? scope.row.parent.ten_danh_muc : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Trạng thái",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Cấp số" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.cap_so), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, null, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(scope.row.mo_ta ? scope.row.mo_ta : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.INFO,
              "color-type": _ctx.ButtonTypeColors.INFO,
              onClick: ($event: any) => (_ctx.push(`/quan-ly/danh-muc-toa-xe/${scope.row.id}/chi-tiet`))
            }, null, 8, ["button-type", "color-type", "onClick"]),
            _createVNode(_component_ButtonCustom, {
              hidden: "",
              "button-type": _ctx.ButtonsType.TRASH,
              "color-type": _ctx.ButtonTypeColors.DANGER,
              onClick: ($event: any) => (_ctx.onDeleteButtonClicked(scope.row.id))
            }, null, 8, ["button-type", "color-type", "onClick"]),
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.EDIT,
              "color-type": _ctx.ButtonTypeColors.SUCCESS,
              onClick: ($event: any) => (_ctx.push(`/quan-ly/danh-muc-toa-xe/${scope.row.id}/chinh-sua`))
            }, null, 8, ["button-type", "color-type", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["cell-class-name", "data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}